import "./FireButton.css";
import fireImage from "../assets/fire.png";

interface FireButtonProps {
  onFire: () => void;
}

export function FireButton({ onFire }: FireButtonProps) {
  const handleTouchStart = (e: React.TouchEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onFire();
  };

  return (
    <button
      className="fire-button"
      onClick={onFire}
      onTouchStart={handleTouchStart}
      type="button"
    >
      <img src={fireImage} alt="Fire" />
    </button>
  );
}
